import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import PropTypes from 'prop-types';
import LanguageIcon from '@mui/icons-material/Language';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';


export default function Layout() {
  function SidebarFooter({ mini }) {
    return (
      <Typography
        variant="caption"
        sx={{ m: 1, whiteSpace: 'nowrap', overflow: 'hidden' }}
      >
        {mini ? '© Praveen' : `© ${new Date().getFullYear()} Developed by Praveen Kumar`}
      </Typography>
    );
  }

  SidebarFooter.propTypes = {
    mini: PropTypes.bool.isRequired,
  };

  function ToolbarActionsSearch() {
    return (
      <Stack direction="row">
        <Tooltip title="Visit CodingMSTR">
          <div title="CodingMSTR" className="cursor-pointer mt-2" onClick={() => window.open('https://codingmstr.com', '_blank')}>
            <LanguageIcon color="action" />
          </div>
        </Tooltip>
      </Stack>
    );
  }

  return (
    <DashboardLayout
      slots={{
        toolbarActions: ToolbarActionsSearch,
        sidebarFooter: SidebarFooter,
      }}
    >
      <Outlet />
    </DashboardLayout>
  );
}